module.exports = "<p-autoComplete\r\n        [(ngModel)]=\"searchText\"\r\n        [suggestions]=\"manufacturerList\"\r\n        [minLength]=\"1\"\r\n        [field]=\"'name'\"\r\n        (completeMethod)=\"search($event)\"\r\n        (onSelect)=\"onSelect($event)\"\r\n        (onClear)=\"onClear($event)\"\r\n        inputStyleClass=\"form-control\"\r\n        [dataKey]=\"'cuid'\"\r\n        appendTo=\"body\">\r\n</p-autoComplete>"


//////////////////
// WEBPACK FOOTER
// ./src/app/crm/manufacturer/manufacturer-input-field/manufacturer-input-field.component.html
// module id = ./src/app/crm/manufacturer/manufacturer-input-field/manufacturer-input-field.component.html
// module chunks = main